// EVENTS.VIEWS.APP.SETTINGS.USER

export const USER = {
  PAGE_VISITED: 'user_settings-page_visited',
  UPDATE_DETAILS: 'account_settings-update_details',
  UPDATE_AVATAR: 'account_settings-update_avatar'
};
